import { createFileRoute } from '@tanstack/react-router';
import { TeamDeadlinesPage, type DeadlinesTab } from '@/features/obligations/TeamDeadlinesPage';

/**
 * «Scadenze» (03-11-2026; era «Scadenze del team», task 1921). Ci portano la voce di menu in «Risorse
 * umane», la segnalazione al responsabile e «Richiede attenzione» della home. `?tab=training` apre i
 * corsi, dove porta anche il vecchio indirizzo `/workforce/training`.
 */
export const Route = createFileRoute('/_app/hr/deadlines')({
  validateSearch: (s: Record<string, unknown>): { tab?: DeadlinesTab } => ({
    tab: s.tab === 'training' ? 'training' : undefined,
  }),
  component: DeadlinesRoute,
});

function DeadlinesRoute() {
  const { tab } = Route.useSearch();
  return <TeamDeadlinesPage tab={tab} />;
}
